import React from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Link } from 'react-router-dom';
import { PlayCircle } from '@mui/icons-material';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';

const handleData = (data) => {

  const date = moment(data, 'YYYY-MM-DD HH:mm:ss').locale('pt-br');
  return date.format('DD/MM/YYYY')
}


const handleHoray = (data) => {
  const newDate = new Date(data)
  let diffTimezoneInMinutes = newDate.getTimezoneOffset() / 60
  let dtRef = diffTimezoneInMinutes > 0 ? new Date(newDate.setHours(newDate.getHours() - diffTimezoneInMinutes))
    : new Date(newDate.setHours(newDate.getHours() + diffTimezoneInMinutes))

  let hours = dtRef.getUTCHours();
  let minutes = dtRef.getUTCMinutes();

  // Adiciona um zero à esquerda se as horas ou minutos forem menores que 10
  hours = hours < 10 ? '0' + hours : hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;

  return `${hours}:${minutes}`;
}




const ConfirmDialog = ({
  title,
  text,
  open,
  onClose,
  closeText,
  onConfirm,
  confirmText,
  hideClose,
  content,
  noPadding,
  actions,
  scroll,
  company,
  user,
  data,
  companyName,
  location,
  dtRegister,
  type
}) => (
  <React.Fragment>
    <Dialog
      open={open}
      onClose={onClose}
      scroll={scroll}
      PaperProps={{
        style: {
          borderRadius: 20,
          alignItems: 'center',
          justifyContent: 'center',
          width: '400px',
          height: '600px'

        }
      }}
    >
      {
        type == 'I' ?
          <PlayCircle style={{ color: '#00cc46', width: '35%', height: '15%', marginTop: '10px' }} />
          :
          <StopCircleIcon style={{ color: '#e01b38', width: '35%', height: '15%', marginTop: '10px' }} />
      }

      <DialogTitle>{type == 'I' ? "Sua entrada está registrada." : "Sua saída está registrada."}</DialogTitle>
      <DialogContentText style={{ color: '#14539a', fontSize: '25px', fontWeight: 'bold', marginBottom: '-10px' }}>{type == 'I' ? "Bom trabalho," : "Bom descanso,"}</DialogContentText>
      <DialogContentText style={{ color: '#14539a', fontSize: '20px', fontWeight: 'bold' }}>{user?.employeeName ? user?.employeeName : data?._employee.name}</DialogContentText>
      <Typography
        variant="h4"
        style={{
          display: 'flex',
          padding: '10px',
          border: '1px solid black',
          borderRadius: '10px',
          verticalAlign: 'middle',
          alignItems: 'center',
          width: '95%'
        }}
      >
        <a style={{ fontSize: '11px' }}>Empresa:</a><a style={{ fontSize: '20px', marginLeft: '15px', color: '#50535b', fontWeight: 'bold' }}>
          {companyName ? companyName : company?.companies?.[0].socialName}
        </a>
      </Typography>
      <Typography
        variant="h4"
        style={{
          display: 'flex',
          padding: '10px',
          border: '1px solid black',
          borderRadius: '10px',
          verticalAlign: 'middle',
          alignItems: 'center',
          width: '95%',
          marginTop: '5px'
        }}
      >
        <a style={{ fontSize: '11px' }}>Endereço:</a>
        <a style={{ fontSize: '13px', marginLeft: '15px', color: '#50535b', fontWeight: 'bold' }}>
          {location ? location :
            (company?.companies?.[0].address && company?.companies?.[0].district && company?.companies?.[0].city && company?.companies?.[0].state) ?
              `${company.companies[0].address} ${company.companies[0].district} - ${company.companies[0].city} - ${company.companies[0].state}` :
              'Sem endereço cadastrado'}
        </a>
      </Typography>
      <Typography
        variant="h4"
        style={{
          display: 'flex',
          padding: '10px',
          border: '1px solid black',
          borderRadius: '10px',
          verticalAlign: 'middle',
          alignItems: 'center',
          width: '95%',
          marginTop: '5px'
        }}
      >
        <a style={{ fontSize: '11px' }}>Data:</a><a style={{ fontSize: '20px', marginLeft: '15px', color: '#50535b', fontWeight: 'bold' }}>
          {/* {new Date(data?.dtRegister).getDate() + '/' + new Date(data?.dtRegister).getMonth() + '/' + new Date(data?.dtRegister).getFullYear()} */}
          {
            handleData(dtRegister)
          }
        </a>
      </Typography>
      <Typography
        variant="h4"
        style={{
          display: 'flex',
          padding: '10px',
          border: '1px solid black',
          borderRadius: '10px',
          verticalAlign: 'middle',
          alignItems: 'center',
          width: '95%',
          marginTop: '5px'
        }}
      >
        <a style={{ fontSize: '11px' }}>Hora:</a><a style={{ fontSize: '20px', marginLeft: '15px', color: '#50535b', fontWeight: 'bold' }}>
          {/* {new Date(data?.dtRegister).getHours() + ':' + new Date(data?.dtRegister).getMinutes()} */}
          {
            handleHoray(dtRegister)
          }
        </a>
      </Typography>
      <DialogActions>
        {
          actions ? actions.map(action => (
            <Button
              component={Link}
              to={action.goTo}
              style={{ margin: 'auto' }}
            >
              {action.title}
            </Button>
          ))
            :
            <>
              {hideClose === true ? null : <Button onClick={onClose}>{closeText || 'CANCELAR'}</Button>}
              <Button onClick={onConfirm} variant="contained" color="primary" autoFocus>
                {confirmText || 'CONFIRMAR'}
              </Button>
            </>
        }
      </DialogActions>
    </Dialog>
  </React.Fragment>
);

ConfirmDialog.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ConfirmDialog;
